// extracted by mini-css-extract-plugin
export var labelWrapper = "_gb-0";